import http from '@/services/http'

export default {
  load (payload) {
    return http.get('/settings')
  }
}
